// GENERATED by scripts/health-icons/build.js from svg-health/ — do not edit; re-run the script.

import { healthIcon } from './index';

// Renders the icon behind a key, or nothing for an unknown/empty key so the
// caller decides its own fallback (the generic stethoscope, by convention).
export default function HealthIcon({ iconKey, variant = 'outline', size = 24, ...rest }) {
  const Icon = healthIcon(iconKey, variant);
  if (!Icon) return null;
  return <Icon size={size} {...rest} />;
}
